const QuizDetail = () => import(/* webpackChunkName: "quizdetails" */ './Index.vue')
const QuizPractice = () => import(/* webpackChunkName: "quizdetails" */ './sub/QuizPractice.vue')

export { QuizDetail, QuizPractice }
